export default __webpack_public_path__ + "static/media/more-info-icon.659a6d7c.svg";